import { render, staticRenderFns } from "./display_target.vue?vue&type=template&id=1ccbaf29&scoped=true&lang=pug&"
import script from "./display_target.vue?vue&type=script&lang=js&"
export * from "./display_target.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccbaf29",
  null
  
)

export default component.exports